import { type State } from '../../types';

export const getIsInlineJoinPending = (state: State): boolean => state.ui.inlineJoin.isJoinPending;
